







import { Component, Prop, Vue } from "vue-property-decorator";
import native from "@/common/Native";
import { Base64 } from "js-base64";
@Component({
  components: {}
})
export default class ImageViewMu extends Vue {
  @Prop()
  appId!: string | number;
  @Prop()
  word!: string;
  @Prop()
  url!: any;
  @Prop()
  sty!: any;
  @Prop()
  newInfo!: any;

  // 查看更多
  checkMore() {
    if (native.isOpenInApp()) {
      console.log(this.newInfo.contentUrl);
      ZWY_CLOUD.redirectUrl({
        id: this.newInfo.infoClassifyId,
        sourceId: this.newInfo.infoClassifyId,
        detailViewType: "",
        sourceType: "1",
        commentType: this.newInfo.commentType,
        contextType: this.newInfo.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "0",
        url: this.newInfo.contentUrl,
        shareUrl: this.newInfo.contentUrl,
        title: Base64.encode(this.newInfo.title), //base 64
        synopsis: Base64.encode(this.newInfo.synopsis), //base 64
        shareImgUrl: this.newInfo.imgUrl
      });
    } else {
      window.location.href = this.url;
    }
  }
}
